import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import * as echarts from "echarts";

import "../../styles/style.scss";

//MUI
import Grid from "@mui/material/Grid";
import { Box, Divider, Stack, Button, Select } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

//API
import { fni18n } from "../../services/commonService";
import { API, PAGE } from "../../config";
import { getAPI, fnCallPopUp } from "../../services/commonService";
import AuthenticationService from "../../pages/auth/AuthenticationService";
import DashDetail from "./DashDetail";

// custom UI
import UTableDashboard from "../../components/mui/UTableDashboard";
import UBreadCrumbs from "../../components/mui/UBreadCrumbs";
import UButton from "../../components/mui/UButton";
import USelectBox from "../../components/mui/USelectBox";
import UPopupForm from "../../components/mui/UPopupForm";

const COLOR_OFFLINE = "#a0a0a0"; //grey
const COLOR_NORMAL = "#006605"; //green
const COLOR_WARNING = "#d4bf00"; //yellow
const COLOR_ERROR = "#cc0000"; //red
const MODULE_COLOR_NORMAL = "#6baf5e";
const MODULE_TEXT_COLOR = "#ffffff";
const BAR_CHART_WIDTH = "50%";

// let BILL_MAX_CNT = 3200
let BILL_WARN_CNT = 200;
let BILL_ERROR_CNT = 50;
// let COIN_MAX_CNT = 1000
let COIN_WARN_CNT = 200;
let COIN_ERROR_CNT = 50;
// let REJECT_MAX_CNT = 1000
let REJECT_WARN_CNT = 500;
let REJECT_ERROR_CNT = 900;

const BILL_TYPE = [
  {
    type: "$100",
    typeName: "usd100DollarCnt",
    capa: 1200,
  },
  {
    type: "$50",
    typeName: "usd50DollarCnt",
    capa: 1200,
  },
  {
    type: "$20",
    typeName: "usd20DollarCnt",
    capa: 1200,
  },
  {
    type: "$10",
    typeName: "usd10DollarCnt",
    capa: 3200,
  },
  {
    type: "$5",
    typeName: "usd5DollarCnt",
    capa: 1200,
  },
  {
    type: "$1",
    typeName: "usd1DollarCnt",
    capa: 3200,
  },
];
const COIN_TYPE = [
  {
    type: "25¢",
    typeName: "usd25CentCnt",
    capa: 1000,
  },
  {
    type: "10¢",
    typeName: "usd10CentCnt",
    capa: 1000,
  },
  {
    type: "5¢",
    typeName: "usd5CentCnt",
    capa: 1000,
  },
  {
    type: "1¢",
    typeName: "usd1CentCnt",
    capa: 1000,
  },
];
const REJECT_TYPE = [
  {
    type: "A",
    typeName: "inBillboxCnt",
    capa: 1000,
  },
  {
    type: "B",
    typeName: "inRejtCnt",
    capa: 1000,
  },
  {
    type: "C",
    typeName: "outRejtCnt",
    capa: 1000,
  },
];
const defaultBillChartOptions = {
  grid: {
    left: "3%",
    right: "4%",
    bottom: "5%",
    containLabel: true,
  },
  xAxis: {
    type: "category",
    data: BILL_TYPE.map((item) => item.type),
  },
  yAxis: {
    type: "value",
  },
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow",
    },
  },
  series: [
    {
      data: BILL_TYPE.map((item) => 0),
      type: "bar",
    },
  ],
};
const defaultCoinChartOptions = {
  grid: {
    left: "3%",
    right: "4%",
    bottom: "5%",
    containLabel: true,
  },
  xAxis: {
    type: "category",
    data: COIN_TYPE.map((item) => item.type),
  },
  yAxis: {
    type: "value",
  },
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow",
    },
  },
  series: [
    {
      data: COIN_TYPE.map((item) => 0),
      type: "bar",
    },
  ],
};
const defaultRejectChartOptions = {
  grid: {
    left: "3%",
    right: "4%",
    bottom: "5%",
    containLabel: true,
  },
  xAxis: {
    type: "category",
    data: ["A", "B", "C"], //A:추가입금리젝함, B:출금리젝함, C:입금리젝함
  },
  yAxis: {
    type: "value",
  },
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow",
    },
  },
  series: [
    {
      data: REJECT_TYPE.map((item) => 0),
      type: "bar",
    },
  ],
};

const url = "wss://" + window.location.host.split(":")[0] + ":8081/ws/dashboard";
const websocket = new WebSocket(url);

const DashboardPage = () => {
  websocket.onmessage = onWsMessage;
  websocket.onopen = onWsOpen;
  websocket.onclose = onWsClose;

  function onWsOpen() {
    console.log("웹소켓 열림");
    // websocket.send("웹소켓 열림!!!");
  }
  function onWsClose() {
    console.log("웹소켓 닫힘");
    // websocket.send("웻소켓 닫힘!!!");
  }
  async function onWsMessage(msg) {
    console.log(msg);

    try {
      await getAPI(API.OPER.STATUS, searchVal)
        .then((res) => {
          setList(res.data.result);
        })
        .catch((err) => {
          console.log("Search Error! ", err);
        });
    } catch (e) {
      console.log(e);
    }

    try {
      await getAPI(API.MAIN.CASH, detailSearchVal)
        .then((res) => {
          setRowSelected(res.data.result[0]);
        })
        .catch((err) => {
          console.log("detail Error! ", err);
        });
    } catch (e) {
      console.log(e);
    }
  }

  function sendWsMessage(msg) {
    websocket.send(msg);
  }

  const userLoginId = AuthenticationService.getLoggedInUserID();
  const [list, setList] = useState([]); // 조회 결과 리스트
  const [rowSelected, setRowSelected] = useState({}); // detail 조회 결과 리스트
  const [moduleStatus, setModuleStatus] = useState({}); //모듈 상태
  const [retailers, setRetailers] = useState([]);
  const [branchCombo, setBranchCombo] = useState([]); //지점 콤보
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [searchVal, setSearchVal] = useState({
    // bizTy: "",
    // branch: "N/A",
    // machineNo: "ALL",
  });
  const [detailSearchVal, setDetailSearchVal] = useState({
    storeCd: "",
    machId: "",
    storeName: "",
  });

  const [formOpen, setFormOpen] = useState(false);
  const [page, setPage] = useState(1);

  const billChartRef = useRef(null);
  const coinChartRef = useRef(null);
  const rejectChartRef = useRef(null);

  const EPPRef = useRef(null);
  const SIURef = useRef(null);
  const CORef = useRef(null);
  const CIRef = useRef(null);
  const CFRef = useRef(null);
  const CCRef = useRef(null);
  const CCoRef = useRef(null);

  const RCTRef = useRef(null);
  const CRMRef = useRef(null);

  //chart settings
  const billChartOptions = useMemo(() => {
    let billChartData0 = [];
    if (!rowSelected) {
      return defaultBillChartOptions;
    }

    BILL_TYPE.map((type) => {
      const data = {
        id: type.typeName,
        value: rowSelected[type.typeName],
        itemStyle: {
          color:
            rowSelected[type.typeName] < BILL_ERROR_CNT
              ? COLOR_ERROR
              : rowSelected[type.typeName] < BILL_WARN_CNT
              ? COLOR_WARNING
              : COLOR_NORMAL,
        },
      };
      billChartData0.push(data);
    });
    const options = {
      legend: {},
      grid: {
        top: "15%",
        left: "5%",
        right: "5%",
        bottom: "5%",
        containLabel: true,
        
      },
      xAxis: {
        type: "category",
        data: BILL_TYPE.map((item) => item.type),
      },
      yAxis: {
        type: "value",
        // max: BILL_MAX_CNT,
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      series: [
        {
          data: billChartData0,
          type: "bar",
          barWidth: BAR_CHART_WIDTH,
          label: {
            show: true,
            position: 'inside',
            color:'white',
            formatter: (params) => {
              return params.value > 0 ? params.value : '';
            }
          },
        },
      ],
    };
    return options;
  }, [rowSelected]);

  const coinChartOptions = useMemo(() => {
    let coinChartData0 = [];
    if (!rowSelected) {
      return defaultCoinChartOptions;
    }

    COIN_TYPE.map((type) => {
      const data = {
        id: type.typeName,
        value: rowSelected[type.typeName],
        itemStyle: {
          color:
            rowSelected[type.typeName] < COIN_ERROR_CNT
              ? COLOR_ERROR
              : rowSelected[type.typeName] < COIN_WARN_CNT
              ? COLOR_WARNING
              : COLOR_NORMAL,
        },
      };
      coinChartData0.push(data);
    });
    const options = {
      grid: {
        top: "15%",
        left: "5%",
        right: "5%",
        bottom: "5%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: COIN_TYPE.map((item) => item.type),
      },
      yAxis: {
        type: "value",
        // max: COIN_MAX_CNT,
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      series: [
        {
          data: coinChartData0,
          type: "bar",
          barWidth: BAR_CHART_WIDTH,
          label: {
            show: true,
            position: 'inside',
            color:'white',
            formatter: (params) => {
              return params.value > 0 ? params.value : '';
            }
          },
        },
      ],
    };
    return options;
  }, [rowSelected]);

  const rejectChartOptions = useMemo(() => {
    let rejectChartData0 = [];
    if (!rowSelected) {
      return defaultRejectChartOptions;
    }

    REJECT_TYPE.map((type) => {
      const data = {
        id: type.typeName,
        value: rowSelected[type.typeName],
        itemStyle: {
          color:
            rowSelected[type.typeName] > REJECT_ERROR_CNT
              ? COLOR_ERROR
              : rowSelected[type.typeName] > REJECT_WARN_CNT
              ? COLOR_WARNING
              : COLOR_NORMAL,
        },
      };
      rejectChartData0.push(data);
    });
    const options = {
      grid: {
        top: "15%",
        left: "5%",
        right: "5%",
        bottom: "5%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: REJECT_TYPE.map((item) => item.type),
      },
      yAxis: {
        type: "value",
        // max: REJECT_MAX_CNT
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      series: [
        {
          data: rejectChartData0,
          type: "bar",
          barWidth: BAR_CHART_WIDTH,
          label: {
            show: true,
            position: 'inside',
            color:'white',
            formatter: (params) => {
              return params.value > 0 ? params.value : '';
            }
          },
        },
      ],
    };
    return options;
  }, [rowSelected]);


  // 초기 화면 로드
  useEffect(() => {
    const getLoadData = async () => {
    try {
      await Promise.all([
        loadComboBoxBranchGroup(),
        loadComboBoxBranch(),
        loadCountCommonCd()
      ]);
    } catch (e) {
      console.error('초기 로딩 실패:', e.message);
    }
    };
    getLoadData();
  }, []);

  useEffect(() => {
    if (!isFirstLoad) return;
    if (searchVal.branch) {
      handleSearch();
      setIsFirstLoad(false);
    }
  }, [searchVal]);

  const clearSearchVal = ()=>{
    setSearchVal({
      ...searchVal,
      ['branch']: 'N/A',
    });
  }
  // 콤보박스 데이터
  const loadComboBoxBranchGroup = async () => {
      try {
        const res = await getAPI(API.COMMON.BRANCH_GROUP, {userId: userLoginId,branchGroupTy: "BIZ_TY",useYn:"Y"});
        const _inputData = res.data.result.map((m) => ({
            cd: m.id,
            name: m.branchGroupNm,
        }));
        setRetailers(_inputData);
        // await loadComboBoxBranch(_inputData[0].cd);
      } catch (e) {
          console.error(e.message);
      }
  };
  const loadComboBoxBranch = async (param) => {
    try {
      const res = await getAPI(API.COMMON.BRANCH, { userId: userLoginId,bizTy:param });
      const _inputData = res.data.result.map((m) => ({
        cd: m.storeCd,
        name: m.storeNm,
      }));
      setBranchCombo(_inputData);
      if (_inputData.length > 0) {
        setSearchVal({
          ...searchVal,
          ["branch"]: _inputData[0].cd,
        });
      } else { 
        clearSearchVal()
      }

    } catch (e) {
      console.error(e.message);
    }
  };
  const loadComboBoxMachineNo = async (branch) => {
    try {
      const res = await getAPI(API.COMMON.MACHINE + branch);
      const _inputData = res.data.result.map((m) => ({
        cd: m.machId,
        name: m.machId,
      }));
      // setMachineNo(_inputData );
    } catch (e) {
      console.error(e.message);
    }
  };
  /*
        매수 기준 설정값 공통코드로 관리
        CBQ -> MAX/ WARN/ ERROR
        CCQ -> MAX/ WARN/ ERROR
        CRQ -> MAX/ WARN/ ERROR
    */
  // 수량 기준값 로드
  const loadCountCommonCd = async () => {
    try {
      await getAPI(API.SYSTEM.CODE, { cdGubn: "CRQ", useYn: "Y" })
        .then((res) => {
          res.data.result.map((commonCd) =>
            commonCd.cd === "WARN"
              ? (REJECT_WARN_CNT = Number(commonCd.cdNm))
              : commonCd.cd === "ERROR"
              ? (REJECT_ERROR_CNT = Number(commonCd.cdNm))
              : // : commonCd.cd === 'MAX'? REJECT_MAX_CNT = Number(commonCd.cdNm)
                null
          );
        })
        .catch((err) => {
          console.log("CRQ Search Error! ", err);
        });
      await getAPI(API.SYSTEM.CODE, { cdGubn: "CBQ", useYn: "Y" })
        .then((res) => {
          res.data.result.map((commonCd) =>
            commonCd.cd === "WARN"
              ? (BILL_WARN_CNT = Number(commonCd.cdNm))
              : commonCd.cd === "ERROR"
              ? (BILL_ERROR_CNT = Number(commonCd.cdNm))
              : // : commonCd.cd === 'MAX'? BILL_MAX_CNT = Number(commonCd.cdNm)
                null
          );
        })
        .catch((err) => {
          console.log("CBQ Search Error! ", err);
        });
      await getAPI(API.SYSTEM.CODE, { cdGubn: "CCQ", useYn: "Y" })
        .then((res) => {
          res.data.result.map((commonCd) =>
            commonCd.cd === "WARN"
              ? (COIN_WARN_CNT = Number(commonCd.cdNm))
              : commonCd.cd === "ERROR"
              ? (COIN_ERROR_CNT = Number(commonCd.cdNm))
              : // : commonCd.cd === 'MAX'? COIN_MAX_CNT= Number(commonCd.cdNm)
                null
          );
        })
        .catch((err) => {
          console.log("CCQ Search Error! ", err);
        });
    } catch (e) {
      console.log(e);
    }
  };

  //chart settings
  useEffect(() => {
    if (billChartRef.current) {
      const chart = echarts.init(billChartRef.current);
      chart.setOption(billChartOptions);
    }
  }, [billChartOptions, billChartRef]);

  useEffect(() => {
    if (coinChartRef.current) {
      const chart = echarts.init(coinChartRef.current);
      chart.setOption(coinChartOptions);
    }
  }, [coinChartOptions, coinChartRef]);

  useEffect(() => {
    if (rejectChartRef.current) {
      const chart = echarts.init(rejectChartRef.current);
      chart.setOption(rejectChartOptions);
    }
  }, [rejectChartOptions, rejectChartRef]);

  useEffect(() => {
    // 모듈 : CRM, RCT, EPP, SIU, COIN(dis), COIN(dep), CAM(face), CAM(cash), CAM(coin)
    // 0:정상, 1:장애
    const rctJamStatus = moduleStatus.st1; //명세표Jam
    const crmJamStatus = moduleStatus.st2; //지폐Jam
    // const coinJamStatus  = moduleStatus.st3; // 동전Jam
    const rctStatus = moduleStatus.md1; //명세표부 상태
    const crmStatus = moduleStatus.md2; // 현금부 상태
    const eppStatus = moduleStatus.ur5; //epp
    const siuStatus = moduleStatus.ur6; //siu
    const coinInStatus = moduleStatus.md3; //동전출금부 상태
    const coinOutStatus = moduleStatus.md4; //동전입금부 상태
    const cameraFaceStatus = moduleStatus.md8; //카메라(안면)
    const cameraStatus = moduleStatus.md9; //카메라(지폐)
    const cameraCoinStatus = moduleStatus.md10; //카메라(동전)

    RCTRef.current.style.backgroundColor =
      Number(rctStatus) + Number(rctJamStatus) ? COLOR_ERROR : MODULE_COLOR_NORMAL;
    CRMRef.current.style.backgroundColor =
      Number(crmStatus) + Number(crmJamStatus) ? COLOR_ERROR : MODULE_COLOR_NORMAL;
    EPPRef.current.style.backgroundColor = Number(eppStatus)
      ? COLOR_ERROR
      : MODULE_COLOR_NORMAL;
    SIURef.current.style.backgroundColor = Number(siuStatus)
      ? COLOR_ERROR
      : MODULE_COLOR_NORMAL;
    CORef.current.style.backgroundColor = Number(coinInStatus)
      ? COLOR_ERROR
      : MODULE_COLOR_NORMAL;
    CIRef.current.style.backgroundColor = Number(coinOutStatus)
      ? COLOR_ERROR
      : MODULE_COLOR_NORMAL;
    CFRef.current.style.backgroundColor = Number(cameraFaceStatus)
      ? COLOR_ERROR
      : MODULE_COLOR_NORMAL;
    CCRef.current.style.backgroundColor = Number(cameraStatus)
      ? COLOR_ERROR
      : MODULE_COLOR_NORMAL;
    CCoRef.current.style.backgroundColor = Number(cameraCoinStatus)
      ? COLOR_ERROR
      : MODULE_COLOR_NORMAL;
  }, [rowSelected, moduleStatus]);

  const clearIfEmpty = () => {
    setList([])
    setRowSelected({})
    setDetailSearchVal({})
    setModuleStatus({});
    return
  }
  
  // search status(main grid)
  const handleSearch = async () => {
    if(searchVal.branch=='N/A') clearIfEmpty()
    try {
      await getAPI(API.OPER.STATUS, searchVal)
        .then((res) => {
          if (res.data.result.length !== 0) {
            setList(res.data.result);
            setRowSelected(res.data.result[0]);
            setModuleStatus(
              res.data.result.length ? res.data.result[0] : moduleStatus
            );
            setDetailSearchVal({
              storeName: res.data.result.length ? res.data.result[0].branch : detailSearchVal.storeName,
              storeCd: res.data.result.length ? res.data.result[0].storeCd : detailSearchVal.storeCd,
              machId: res.data.result.length ? res.data.result[0].machId : detailSearchVal.machId,
            });
            sendWsMessage(
              JSON.stringify({
                storeName: res.data.result[0].branch,
                storeCd: res.data.result[0].storeCd,
                machId: res.data.result[0].machId,
              })
            );
          } else {
            clearIfEmpty()
          }
        })
        .catch((err) => {
          console.log("Search Error! ", err);
        });
    } catch (e) {
      console.log(e);
    }
  };
  //검색 조건 변경시 setter
  const onSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchVal({
      ...searchVal,
      [name]: value,
    });
    // if (name === "branch") {
    //   loadComboBoxMachineNo(value);
    // }
    if (name === "bizTy") {
      loadComboBoxBranch(value);
    }
  };
  //차트 로드
  useEffect(() => {
    const getLoadData = async () => {
      try {
        await handleSearchDetail();
      } catch (e) {}
    };
    getLoadData();
  }, [detailSearchVal]);

  //search detail(chart)
  const onSelectedRow = (e, row) => {
    setRowSelected(row);
    setModuleStatus(row);
    setDetailSearchVal({
      storeName: row.branch,
      storeCd: row.storeCd,
      machId: row.machId,
    });
    sendWsMessage(
      JSON.stringify({
        storeName: row.branch,
        storeCd: row.storeCd,
        machId: row.machId,
      })
    );
  };
  const handleSearchDetail = async () => {
    if (!(detailSearchVal.machId && detailSearchVal.storeCd)) {
      setRowSelected(null);
      return;
    }
    await getAPI(API.MAIN.CASH, detailSearchVal)
      .then((res) => {
        setRowSelected(res.data.result[0]);
      })
      .catch((err) => {
        console.log("detail Error! ", err);
      });
  };
  const handleFormOpen = () => {
    setFormOpen(true);
  };
  const handleFormClose = () => {
    setFormOpen(false);
  };
  //define datagrid columns
  const columns = [
    {
      field: "branch",
      headerName: "지점",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "machId",
      headerName: "기기번호",
      width: 100,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "machKndCd",
      headerName: "기종",
      width: 100,
      headerAlign: "center",
      align: "center",
      hide:true,
    },
    {
      field: "ip",
      headerName: "IP",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "status",
      headerName: "상태",
      width: 100,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <FiberManualRecordIcon
          sx={{
            color:
              params.rows.statusCd === "03"
                ? COLOR_ERROR
                : params.rows.statusCd === "99" || params.rows.statusCd === null
                ? COLOR_OFFLINE
                : COLOR_NORMAL,
          }}
        />
      ),
    },
    {
      field: "network",
      headerName: "네트워크",
      width: 100,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <FiberManualRecordIcon
          sx={{
            color:
              params.rows.network === "online"
                ? COLOR_NORMAL
                : COLOR_ERROR,
          }}
        />
      ),
    },
    {
      field: "cstalert",
      headerName: "카세트조작알림",
      width: 100,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <FiberManualRecordIcon
          sx={{
            color:
              params.rows.c1 === "0" && params.rows.c2 === "0" && params.rows.c3 === "0" && params.rows.c4 === "0" 
                ? COLOR_NORMAL
                : COLOR_WARNING,
          }}
        />
      ),
    },
    {
      field: "doorSt",
      headerName: "문상태",
      width: 150,
      headerAlign: "center",
      align: "center",
      valueFormatter: (params) => {
        if (params.value === "Open") {
          return (
            <div
              style={{
                color: "red",
                fontWeight: "bold"
              }}
            >
              {params.value}
            </div>
          )
        } else {
          return (<div>{params.value}</div>)
        }
      },
    },
    {
      field: "ur4",
      headerName: "모드",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "apVer",
      headerName: "AP버전",
      width: 130,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "firmVer",
      headerName: "펌웨어버전",
      width: 130,
      headerAlign: "center",
      align: "center",
      hide:true,
    },
    {
      field: "errCd",
      headerName: "오류번호",
      width: 150,
      headerAlign: "center",
      align: "center",
      hide: true,
    },
    {
      field: "date",
      headerName: "개국일시",
      width: 180,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "detail",
      headerName: "상세",
      width: 100,
      headerAlign: "center",
      align: "center",
      renderCell: (params) =>
        params.rows.statusCd ? (
          <UButton
            icon="View"
            variant="outlined"
            onButtonClick={() => handleFormOpen()}
          >
            보기
          </UButton>
        ) : (
          <></>
        ),
    },
  ];

  return (
    <div className="main-container">
      <Grid container className="header">
        <Grid item xs={10}>
          {/* 상단메뉴명 */}
          <UBreadCrumbs title={"기기정보"} subtitle={"대시보드"} />
        </Grid>
        <Grid item xs={2}>
          {/* 툴바 버튼 */}
          <Stack
            direction="row"
            justifyContent="flex-end"
            alignItems="flex-start"
            spacing={0.5}
          >
          </Stack>
        </Grid>
      </Grid>

      {/* <Divider/>  */}

      <Box className="contents">
        {/* 조회조건 */}
        <TableContainer
          component={Paper}
          elevation={0}
          className="table-container"
        >
          <Table className="table" size="small">
            <TableBody>
              <TableRow className="table-row-header">
                <TableCell className="table-cell-title">{fni18n("고객사")}</TableCell>
                <TableCell className="table-cell">
                  <USelectBox
                    name="bizTy"
                    items={retailers}
                    onItemChange={onSearchChange}
                  />
                </TableCell>
                <TableCell className="table-cell-title">{fni18n("지점")}</TableCell>
                <TableCell className="table-cell">
                  {/* 점번선택 */}
                  <USelectBox
                    name="branch"
                    items={branchCombo}
                    defaultValue={searchVal.branch}
                    onItemChange={onSearchChange}
                  />
                </TableCell>
                {/* <TableCell className="table-cell-title">{fni18n('기기번호')}</TableCell>
                    <TableCell className="table-cell">
                    <USelectBox
                    name="machineNo"
                    items={machineNo}
                    onItemChange={onSearchChange}/>
                    </TableCell> */}
                <TableCell className="table-cell"></TableCell>
                <TableCell className="table-cell"></TableCell>
                <TableCell className="table-cell" colSpan={6} align="right">
                  {/* 상태표기  */}
                  <FiberManualRecordIcon
                    sx={{
                      ml: 1,
                      color: COLOR_OFFLINE,
                    }}
                  />
                  <span style={{ verticalAlign: "super", fontSize: "0.8rem", paddingLeft: "5px" }}>{fni18n("오프라인")}</span>
                  <FiberManualRecordIcon
                    sx={{
                      ml: 1,
                      color: COLOR_NORMAL,
                    }}
                  />
                  <span style={{ verticalAlign: "super", fontSize: "0.8rem", paddingLeft: "5px" }}>{fni18n("정상 ")}</span>
                  <FiberManualRecordIcon
                    sx={{
                      ml: 1,
                      color: COLOR_WARNING,
                    }}
                  />
                  <span style={{ verticalAlign: "super", fontSize: "0.8rem", paddingLeft: "5px" }}>{fni18n("경고")}</span>
                  <FiberManualRecordIcon
                    sx={{
                      ml: 1,
                      color: COLOR_ERROR,
                    }}
                  />
                  <span style={{ verticalAlign: "super", fontSize: "0.8rem", paddingLeft: "5px", paddingRight: "10px" }}>{fni18n("오류")}</span>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <div className="search">
          <UButton icon="Search" onButtonClick={handleSearch}>
            조회
          </UButton>
        </div>
        {/* END 조회조건 */}
        {/* </Box> */}

        {/* <Divider/> */}

        {/* 조회 리스트 */}
        <UTableDashboard
          columns={columns}
          rows={list}
          rowPerPage={4}
          onSelectedRowChange={onSelectedRow}
          page={page}
          rowSelected={rowSelected}
        />
        {/* <UDataGrid columns={columns} data={list} limitRow={5} height={500} onSelectedRow={onSelectedRow} />  */}
        {/* <DataGrid
                    sx={{fontSize: "16px", minHeight: "350px", fontFamily: "Arial"}}
                    rowHeight={40}
                    getRowId={(row) => row.id}
                    columns={columns}
                    rows={list}
                    loading={loading}
                    onRowClick={(row) => onSelectedRow(row)}
                    hideFooterSelectedRowCount
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    experimentalFeatures={{ columnGrouping: true }}
                    components={{
                    Pagination: UPagination,
                    NoRowsOverlay: () => (
                      <Stack height="100%" justifyContent="center" alignItems="center">
                        {fni18n('조회결과 없음')}
                      </Stack>
                    ),
                    }}
                />   */}
      </Box>
      {/* END 조회 리스트 */}
      {/* <UPopupForm
            open={formOpen}
            onClose={handleFormClose}
            title={"Status Detail"}
            type={"1"}
            content={<DashboardPopUpPage data={machId} />}
        />  */}
      <UPopupForm
        open={formOpen}
        onClose={handleFormClose}
        title={"상세"}
        type={"1"}
        content={<DashDetail data={detailSearchVal} />}
      />
      {/* <Divider/>  */}

      {/* 하단 차트 */}
      <div
        style={{
          marginLeft: 5,
          marginRight: -5,
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="stretch"
          spacing={1}
        >
          {/* 1 bill chart */}
          <Box
            sx={{
              width: "43%",
              height: 320,
              border: "1px solid #eceff1",
              backgroundColor: "background.default",
              borderRadius: 2,
              // borderTop: "2px solid #2F2F2F",
            }}
          >
            <div
              style={{
                paddingTop: 5,
                paddingBottom: 5,
                fontSize: "0.8rem",
                textAlign: "center",
                fontWeight: "bold",
                backgroundColor: "#f1f1f1"
              }}
            >
              {fni18n("지폐")}
            </div>
            <div
              ref={billChartRef}
              style={{
                width: "100%",
                height: "90%",
                display: "flex",
                justifyContent: "center"
              }}
            />
          </Box>

          {/* 2 coin chart */}
          <Box
            sx={{
              width: "27%",
              height: 320,
              border: "1px solid #eceff1",
              backgroundColor: "background.default",
              borderRadius: 2,
              // borderTop: "2px solid #2F2F2F",
            }}
          >
            <div
              style={{
                paddingTop: 5,
                paddingBottom: 5,
                fontSize: "0.8rem",
                textAlign: "center",
                fontWeight: "bold",
                backgroundColor: "#f1f1f1"
              }}
            >
              {fni18n("동전")}
            </div>
            <div
              ref={coinChartRef}
              style={{
                width: "100%",
                height: "90%",
                display: "flex",
                justifyContent: "center"
              }}
            />
          </Box>

          {/* 3 reject chart */}
          <Box
            sx={{
              width: "20%",
              height: 320,
              border: "1px solid #eceff1",
              backgroundColor: "background.default",
              borderRadius: 2,
              // borderTop: "2px solid #2F2F2F",
            }}
          >
            <div
              style={{
                paddingTop: 5,
                paddingBottom: 5,
                fontSize: "0.8rem",
                textAlign: "center",
                fontWeight: "bold",
                backgroundColor: "#f1f1f1"
              }}
            >
              {fni18n("리젝")}
            </div>
            <div
              ref={rejectChartRef}
              style={{
                width: "100%",
                height: "90%",
                display: "flex",
                justifyContent: "center"
              }}
            />
          </Box>

          {/* Module Status */}
          <Box
            sx={{
              width: "20%",
              height: 320,
              border: "1px solid #eceff1",
              backgroundColor: "background.default",
              borderRadius: 2,
              // borderTop: "2px solid #2F2F2F",
            }}
          >
            <div
              style={{
                paddingTop: 5,
                paddingBottom: 5,
                fontSize: "0.8rem",
                textAlign: "center",
                fontWeight: "bold",
                backgroundColor: "#f1f1f1"
              }}
            >
              {fni18n("모듈상태")}
            </div>
            <Box
              sx={{
                width: "100%",
                height: "90%",
                display: "flex",
                padding: 2,
                flexDirection: "column",
                alignItems: "center", // 내용이 중앙에 오도록 설정
              }}
            >
              <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column", // 세로 방향으로 배치
                    justifyContent: "space-around", // 세로로 중앙 정렬
                    alignItems: "center", // 가로로 중앙 정렬
                  }}
              >


                {/* 첫 번째 줄: 4개 버튼 */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    height: "100%",
                    // marginTop: 16, // 첫 줄과 "Module Status" 사이 간격
                  }}
                >
                  <Button
                    ref={CRMRef}
                    size="small"
                    variant="contained"
                    sx={{
                      width: "23%",
                      backgroundColor: MODULE_COLOR_NORMAL,
                      color: MODULE_TEXT_COLOR,
                      cursor: "default",
                    }}
                  >
                    {fni18n("현금부")}
                  </Button>
                  <Button
                    ref={RCTRef}
                    size="small"
                    variant="contained"
                    sx={{
                      width: "23%",
                      backgroundColor: MODULE_COLOR_NORMAL,
                      color: MODULE_TEXT_COLOR,
                      cursor: "default",
                    }}
                  >
                    {fni18n("명세표부")}
                  </Button>
                  <Button
                    ref={EPPRef}
                    size="small"
                    variant="contained"
                    sx={{
                      width: "23%",
                      backgroundColor: MODULE_COLOR_NORMAL,
                      color: MODULE_TEXT_COLOR,
                      cursor: "default",
                    }}
                  >
                    {fni18n("핀패드")}
                  </Button>
                  <Button
                    ref={SIURef}
                    size="small"
                    variant="contained"
                    sx={{
                      width: "23%",
                      backgroundColor: MODULE_COLOR_NORMAL,
                      color: MODULE_TEXT_COLOR,
                      cursor: "default",
                    }}
                  >
                    {fni18n("고객조작부")}
                  </Button>
                </div>

                {/* 두 번째 줄: 2개 버튼 */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    height: "100%",
                    marginTop: 16, // 첫 줄과 두 번째 줄 사이 간격
                  }}
                >
                  <Button
                    ref={CORef}
                    size="small"
                    variant="contained"
                    sx={{
                      width: "49%",
                      backgroundColor: MODULE_COLOR_NORMAL,
                      color: MODULE_TEXT_COLOR,
                      cursor: "default",
                    }}
                  >
                    {fni18n("동전출금부")}
                  </Button>
                  <Button
                    ref={CIRef}
                    size="small"
                    variant="contained"
                    sx={{
                      width: "49%",
                      backgroundColor: MODULE_COLOR_NORMAL,
                      color: MODULE_TEXT_COLOR,
                      cursor: "default",
                    }}
                  >
                    {fni18n("동전입금부")}
                  </Button>
                </div>

                {/* 세 번째 줄: 3개 버튼 */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    height: "100%",
                    marginTop: 16, // 두 번째 줄과 세 번째 줄 사이 간격
                  }}
                >
                  <Button
                    ref={CFRef}
                    size="small"
                    variant="contained"
                    sx={{
                      width: "32%",
                      backgroundColor: MODULE_COLOR_NORMAL,
                      color: MODULE_TEXT_COLOR,
                      cursor: "default",
                    }}
                  >
                    {fni18n("카메라(안면)")}
                  </Button>
                  <Button
                    ref={CCRef}
                    size="small"
                    variant="contained"
                    sx={{
                      width: "32%",
                      backgroundColor: MODULE_COLOR_NORMAL,
                      color: MODULE_TEXT_COLOR,
                      cursor: "default",
                    }}
                  >
                    {fni18n("카메라(지폐)")}
                  </Button>
                  <Button
                    ref={CCoRef}
                    size="small"
                    variant="contained"
                    sx={{
                      width: "32%",
                      backgroundColor: MODULE_COLOR_NORMAL,
                      color: MODULE_TEXT_COLOR,
                      cursor: "default",
                    }}
                  >
                    {fni18n("카메라(동전)")}
                  </Button>
                </div>
              </div>
            </Box>
          </Box>

        </Stack>
      </div>
      {/* END 하단 차트 */}
    </div>
  );
};

export default DashboardPage;
